module.exports = __webpack_public_path__ + "static/media/page81_02.bed41fe5.png";